"use client";

import { Skeleton } from "@offstreetparking/design-system/feedback";
import dynamic from "next/dynamic";

type LazyQRCodeSVGProps = {
	size: number;
	value: string;
	level?: "L" | "M" | "Q" | "H";
};

const QRCodeSVG = dynamic(() => import("qrcode.react").then((m) => m.QRCodeSVG), {
	ssr: false,
	loading: () => <Skeleton className="absolute inset-0" />,
});

export const preloadQRCodeChunk = (): Promise<unknown> => import("qrcode.react");

export const LazyQRCodeSVG = ({ size, value, level = "H" }: LazyQRCodeSVGProps) => (
	<span className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
		<QRCodeSVG size={size} value={value} level={level} />
	</span>
);
